export const fiscalStateOptions = [
  { label: "Persona física", value: "PHYSICAL_PERSON" },
  { label: "Persona moral", value: "MORAL_PERSON" },
  { label: "No estoy dado de alta", value: "NOT_REGISTERED" }
];